import { makeAutoObservable, runInAction } from "mobx";
import { SubmitRatingDto, UserRatingResponse } from "../models/UserRatingModels";
import { agent } from "../api/agent";


export default class UserRatingStore {
    userRatingData: UserRatingResponse | null = null;
    loading = false;
    submitting = false;
    
    constructor() {
        makeAutoObservable(this);
    }

    loadUserRatings = async (userId: string, sportId?: string) => {
        this.loading = true;
        try {
            const data = await agent.UserRatings.getUserRatings(userId, sportId);
            runInAction(() => {
                this.userRatingData = data;
                this.loading = false;
            });
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            });
            console.error('Error loading user ratings:', error);
            throw error;
        }
    };

    submitRating = async (rating: SubmitRatingDto) => {
        this.submitting = true;
        try {
            await agent.UserRatings.submitRating(rating);
            runInAction(() => {
                this.submitting = false;
            });
            // Reload data after successful submission
            await this.loadUserRatings(rating.ratedUserId);
        } catch (error) {
            runInAction(() => {
                this.submitting = false;
            });
            console.error('Error submitting rating:', error);
            throw error;
        }
    };

    updateCommentApproval = async (commentId: string, isApproved: boolean) => {
        try {
            await agent.UserRatings.updateCommentApproval({ commentId, isApproved });
            
            runInAction(() => {
                if (this.userRatingData?.comments) {
                    const comment = this.userRatingData.comments.find(c => c.id === commentId);
                    if (comment) {
                        comment.isApproved = isApproved;
                    }
                }
            });
        } catch (error) {
            console.error('Error updating comment approval:', error);
            throw error;
        }
    };

    clearUserRatingData = () => {
        this.userRatingData = null;
    };
}